import { render } from "./OtherAssetNewModalPopup.vue?vue&type=template&id=1fb525ac&scoped=true"
import script from "./OtherAssetNewModalPopup.vue?vue&type=script&lang=js"
export * from "./OtherAssetNewModalPopup.vue?vue&type=script&lang=js"

import "./OtherAssetNewModalPopup.vue?vue&type=style&index=0&id=1fb525ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb525ac"]])

export default __exports__